/** Panels copy in Arabic. Mirrors `../../en/home/panels.js` key for key. */
import panelAdmin from '@/assets/images/panels/admin.webp'
import panelHr from '@/assets/images/panels/hr.webp'
import panelReception from '@/assets/images/panels/reception.webp'
import panelUser from '@/assets/images/panels/user.webp'

export const PANELS = {
  eyebrow: 'تطبيق واحد',
  title: 'أربع لوحات، جدول واحد',
  text: 'يرى كل دور ما يحتاجه، ويبقى كل شيء متزامنًا.',
  items: [
    {
      title: 'لوحة المستخدم',
      tag: 'الحجز والانضمام',
      image: panelUser,
      text: 'جدول الاجتماعات، واختر القاعات، واطّلع على الدعوات وأسبوعك في تقويم واحد.',
      rows: [
        { label: 'لمن', value: 'جميع أعضاء الفريق' },
        { label: 'تتضمن', value: 'التقويم، القاعات، الدعوات، الرسائل' },
      ],
    },
    {
      title: 'لوحة الاستقبال',
      tag: 'مكتب الاستقبال',
      image: panelReception,
      text: 'تسجيل دخول الزوار بالتوقيع، وكبار الضيوف، ومن في المقر اليوم، وتنبيهات المضيفين.',
      rows: [
        { label: 'لمن', value: 'موظفو الاستقبال' },
        {
          label: 'تتضمن',
          value: 'الزوار، الزيارات المباشرة، كبار الضيوف، تنبيهات المضيفين',
        },
      ],
    },
    {
      title: 'لوحة الموارد البشرية',
      tag: 'الموافقات',
      image: panelHr,
      text: 'وافق على طلبات القاعات والأعضاء الجدد، وتابع كيفية استخدام القاعات.',
      rows: [
        { label: 'لمن', value: 'فريق الموارد البشرية' },
        { label: 'تتضمن', value: 'الطلبات، الأعضاء، التقارير' },
      ],
    },
    {
      title: 'لوحة المسؤول',
      tag: 'الإعداد',
      image: panelAdmin,
      text: 'أعدّ القاعات والفروع والأدوار وبيانات الشركة في مكان واحد.',
      rows: [
        { label: 'لمن', value: 'المسؤولون' },
        { label: 'تتضمن', value: 'القاعات، الأدوار، الإعدادات' },
      ],
    },
  ],
}
